import { addItem } from '~/src/features/domofon/purchase/actions/addItem';
import decrementItem from '~/src/features/domofon/purchase/actions/decrementItem';
import incrementItem from '~/src/features/domofon/purchase/actions/IncrementItem';
import { removeItem } from '~/src/features/domofon/purchase/actions/removeItem';
import selectCost from '~/src/features/domofon/purchase/actions/selectCost';
import EEquipmentPurchaseActions from '~/src/features/domofon/purchase/constants/actions';
import { InitialState } from '~/src/features/domofon/purchase/reducer/initialState';

type ItemPayloads =
    | typeof addItem
    | typeof decrementItem
    | typeof incrementItem
    | typeof removeItem
    | typeof selectCost;

const equipmentReducer = (state: InitialState, action: ReturnType<ItemPayloads>): InitialState => {
    switch (action.type) {
        case EEquipmentPurchaseActions.ADD_ITEM: {
            return {
                ...state,
                equipments: {
                    ...state.equipments,
                    [action.payload.id]: {
                        ...state.equipments[action.payload.id],
                        quantity: 1,
                    },
                },
                _totalSelected: state._totalSelected + 1,
            };
        }
        case EEquipmentPurchaseActions.INC_ITEM: {
            return {
                ...state,
                equipments: {
                    ...state.equipments,
                    [action.payload]: {
                        ...state.equipments[action.payload],
                        quantity: state.equipments[action.payload].quantity + 1,
                    },
                },
                _totalSelected: state._totalSelected + 1,
            };
        }
        case EEquipmentPurchaseActions.DEC_ITEM: {
            return {
                ...state,
                equipments: {
                    ...state.equipments,
                    [action.payload]: {
                        ...state.equipments[action.payload],
                        quantity: state.equipments[action.payload].quantity - 1,
                    },
                },
                _totalSelected: state._totalSelected - 1,
            };
        }
        case EEquipmentPurchaseActions.REMOVE_ITEM: {
            return {
                ...state,
                equipments: {
                    ...state.equipments,
                    [action.payload]: { ...state.equipments[action.payload], quantity: 0 },
                },
                _totalSelected: state._totalSelected - state.equipments[action.payload].quantity,
            };
        }
        case EEquipmentPurchaseActions.SELECT_COST: {
            return {
                ...state,
                equipments: {
                    ...state.equipments,
                    [action.payload.equipmentId]: {
                        ...state.equipments[action.payload.equipmentId],
                        selectedPrice: action.payload.costIdx,
                        quantity: 1, // if a new type of purchase select then will flush quantity
                    },
                },
                _totalSelected: state._totalSelected - state.equipments[action.payload.equipmentId].quantity + 1,
            };
        }
    }
};

export default equipmentReducer;
